import * as api from './api';

export const fetchAllBiofuelCircles = async () => {
  try {
    let res = await api.fetchAllBiofuelCircles();
    return res;
  } catch (err) {
    throw err;
  }
};
